<template>
  <div>
    <div class="custom-select form-select" @click="toggleDropdown">
      <div class="selected-icon">
        <i :class="selectedIcon"></i> {{ selectedName }}
      </div>
      <ul v-if="showDropdown" class="icon-dropdown form-control">
        <li
          v-for="icon in iconList"
          :key="icon.name"
          @click="selectIcon(icon)"
          class="dropdown-item form-control"
        >
          <i :class="icon.class"></i> {{ icon.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import icons from "@/icons.json"
export default {
  props: ["value"],
  data() {
    return {
      iconList: icons,
      selectedIcon: "",
      selectedName: "Seleccionar Icono",
      showDropdown: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    selectIcon(icon) {
      this.value.icon = icon.class
      this.selectedIcon = icon.class;
      this.selectedName = icon.name;
       // Cierra el dropdown después de seleccionar
    },
  },
};
</script>

<style scoped>

.custom-select {
  position: relative;
  display: inline-block;
}

.selected-icon {
  cursor: pointer;
}

.icon-dropdown {
  position: absolute;
  min-width: 100%;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 2px;
}

.dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.dropdown-item i {
  margin-right: 10px;
}
.custom-select:hover .icon-dropdown {
  display: block;
}
</style>
